"use client";

import {
  devConfig,
  EquipConfig,
  loadConfigFromStorage,
  prdConfig,
  saveConfigToStorage,
} from "@/models/auth/equipConfig";
import { equipOptionsInstance } from "@/models/EquipOptions";
import {
  AccountInfo,
  Configuration,
  IPublicClientApplication,
  PublicClientApplication,
  SilentRequest,
} from "@azure/msal-browser";
import { GetUserInfo, GetUserRoles } from "../api/user-endpoints";
import { setEquipApiBaseUrl } from "../api/utilities-api";

export class EquipMsalClient {
  private activeSettings: EquipConfig;
  MsalClient: IPublicClientApplication;

  constructor() {
    this.activeSettings = loadConfigFromStorage() ?? prdConfig;
    console.info(`Loaded MSAL config for environment: ${this.activeSettings.TAG}`);
    this.MsalClient = new PublicClientApplication(this.GenerateMsalConfig());
  }

  public async RegenerateClient(newSettings: EquipConfig | undefined = undefined) {
    if (newSettings != undefined) {
      this.activeSettings = newSettings;
      setEquipApiBaseUrl(this.activeSettings.BASE_URL);
      saveConfigToStorage(this.activeSettings);
    }

    this.MsalClient = new PublicClientApplication(this.GenerateMsalConfig());
    await this.MsalClient.initialize();
  }

  public GetAzureUser(): AccountInfo {
    return this.MsalClient.getActiveAccount();
  }

  public async GetToken(): Promise<string> {
    await this.MsalClient.initialize();
    const account = this.MsalClient.getActiveAccount();
    if (!account) throw new Error("Not logged in");

    const response = await this.MsalClient.acquireTokenSilent(this.silentRequest(account));

    if (response?.accessToken == null || response?.accessToken == "")
      throw new Error("No access token");

    return response.accessToken;
  }

  public GetBaseUrl(): string {
    return this.activeSettings.BASE_URL;
  }
  public GetEnvironment(): string {
    return this.activeSettings.TAG;
  }

  GenerateMsalConfig(): Configuration {
    return {
      auth: {
        clientId: this.activeSettings.CLIENT_ID!,
        authority: "https://login.microsoftonline.com/77cbd237-5446-4937-b029-6276e110c885",
        redirectUri: this.activeSettings.REDIRECT_URI,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: "localStorage",
      },
    };
  }

  silentRequest(account: AccountInfo): SilentRequest {
    return {
      scopes: [this.activeSettings.SCOPE!, "openid", "email", "User.Read", "profile"],
      account: account,
      forceRefresh: false,
    };
  }
}

export const equipmsalinstance = new EquipMsalClient();
